module.exports = {
    RECEIVE_UNIT: 'RECEIVE_UNIT',
    RECEIVE_ALL_UNITS: 'RECEIVE_ALL_UNITS',
    RECEIVE_UNIT_NAMES: 'RECEIVE_UNIT_NAMES',
    RESET_UNIT: 'RESET_UNIT',
}
